import { Translate } from 'next-translate';

import { CustomColumnHeader, CustomColumnItem, LineItem, Lot } from 'types';

export const getLotPrefix = (t: Translate, lot: Lot): string => {
  const message = t('line_items.errors.validation_failed');

  if (!lot) return message;

  if (lot.name?.trim()?.length) return `${message}[${lot.name}]`;

  return `${message}[${lot.sno}]`;
};

export const getLineItemPrefix = (
  t: Translate,
  lot: Lot,
  lineItem: LineItem,
): string => {
  const lotPrefix = getLotPrefix(t, lot);

  if (!lineItem) return lotPrefix;

  if (lineItem.name?.trim()?.length) return `${lotPrefix} [${lineItem.name}]`;

  return `${lotPrefix} [${lineItem.sno}]`;
};

export const getCustomColumnItemPrefix = (
  t: Translate,
  lot: Lot,
  lineItem: LineItem,
  customColumnItem: CustomColumnItem,
): string => {
  const lineItemPrefix = getLineItemPrefix(t, lot, lineItem);

  if (!customColumnItem) return lineItemPrefix;

  if (customColumnItem.display_text?.trim()?.length) return `${lineItemPrefix} [${customColumnItem.display_text}]`;

  return `${lineItemPrefix} [${customColumnItem.id}]`;
};

export const getHeaderPrefix = (
  t: Translate,
  lot: Lot,
  header: CustomColumnHeader,
): string => {
  const lotPrefix = getLotPrefix(t, lot);

  if (!header) return lotPrefix;

  if (header.display_text?.trim()?.length) return `${lotPrefix} [${header.display_text}]`;

  return `${lotPrefix} [${header.id}]`;
};

export const messageBlank = (t: Translate, parent: string, field: string): string => (
  t(`line_items.validations.${parent}.${field}.blank`)
);

export const messageInvalid = (t: Translate, parent: string, field: string): string => (
  t(`line_items.validations.${parent}.${field}.invalid`)
);

export const messageNoLineItems = (t: Translate) => (
  messageBlank(t, 'lot', 'line_items')
);

export const messageNoAssociatedCriteriaId = (t: Translate): string => (
  messageBlank(t, 'associated_criteria', 'id')
);
